import _ from "lodash";
import WidgetSkeleton from "./WidgetSkeleton";
import WidgetDataLabel from "./WidgetDataLabel";
import WidgetMessage, { BaseWidgetMessages } from "./WidgetMessage";
import { Card, Col } from "react-bootstrap";
import { ThemedSpan } from "../../../components/utilities";
import { useAssetsSummaryData } from "../hooks/AssetsSummaryContext";
import { toCommas } from "../../../helpers/numbers";

const WidgetBody = () => {
    const { data, error } = useAssetsSummaryData();

    if (error) {
        return <WidgetMessage icon={['fas', 'exclamation']} message={BaseWidgetMessages.Error} />
    }

    if (!data || data.length < 1) {
        return <WidgetMessage message={BaseWidgetMessages.NoResult} />
    }

    return (
        <>
            {data.serviceLevelAgreementList.map((item, i) => (
                <WidgetDataLabel 
                    key={i}
                    includeCenter={true}
                    label={`${item.serviceAgreementName}`}
                    centerValue={toCommas(item.clientCount)}
                    value={item.value.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })}
                />
            ))}
            <WidgetDataLabel 
                className="mt-4"
                includeCenter={true}
                label={`Total`}
                isLabelBold={true}
                centerValue={toCommas(data.totalClientCount)}
                value={data.totalValue.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })}
            />
        </>
    );
}

export const AssetsWidget = () => {
    const { isFetching, isLoading } = useAssetsSummaryData();

    if (isFetching || isLoading) {
        return <WidgetSkeleton />
    }

    return (
        <Col xs={12} sm={12} md={6} lg={6} xl={4}>
            <a className="text-reset text-decoration-none" href={"/client/search"}>
                <Card className="overflow-hidden" style={{ height: "300px", color: "dodgerblue" }}>
                    <Card.Body>
                        <Card.Title className="pb-2" style={{ fontSize: "18px" }}>
                            <ThemedSpan variant="primary" className="fw-bold">Assets</ThemedSpan>
                        </Card.Title>
                        <Card.Text as="div" className="row g-2">
                            <WidgetBody />
                        </Card.Text>
                    </Card.Body>
                </Card>
            </a>
        </Col>
    );
}